import {SEARCH_RESULT} from "../../../types";

export const searchResult = (data) => ({
    type: SEARCH_RESULT,
    data
})

export const dispatchBooks = (data) => dispatch => 
    dispatch(searchResult(data))